
<script>
import { searchService } from "../../services";
import { required } from "vuelidate/lib/validators";
import config from "../../config";
import { error_message } from "../../Helper/helper";
import { success_message } from "../../Helper/helper";
import Multiselect from "vue-multiselect";

export default {
    components: {searchService, Multiselect},
    data() {
        return {
            items: [],
            type: [],
            isLoading: false,
            config: config,
            typeform: {
                type: "",
                type_id: ""
            },
        };
    },
    validations: {
        typeform: {
            type: {
                required,
            },
            type_id: {
                required,
            }
        }
    },
    methods: {

        addPopularSearch() {
            this.$v.$touch();
            if (this.$v.typeform.$invalid) {
                setTimeout(()=>{
                    $(".is-invalid:first").focus();
                },500);
                return;
            } else {
                searchService.addPopularSearch(this.typeform).then((response) => {
                if (response.data.code === 200) {
                    success_message(response.data.message);
                    this.$router.push({ name: "popular-search" });
                } else {
                    error_message(response.data.message);
                }
                });
            }
        },
        getData(event){
            this.typeform.type = event.target.value;
            searchService.getPopularSearchData({type : this.typeform.type})
            .then((response) => {
                // this.items = response.data.result;
                this.items = response.data.result.sort((a, b) => {
                    return a.name.localeCompare(b.name);
                });
                this.typeform.type_id = '';
            });
        },
        asyncPopularSearch(query) {
            this.isLoading = true;
            searchService.getPopularSearch({ search: query, type: this.typeform.type })
            .then((response) => {
                this.items = response.data.result;
                this.items = response.data.result.sort((a, b) => {
                    return a.name.localeCompare(b.name);
                });
                this.isLoading = false;
            });
        },
    },
};
</script>

<template>
    <form @submit.prevent="addPopularSearch">
        <!-- Popular Search Start -->
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Popular Search') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">
                    <div class="col-sm-5">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Select Type') }}</label>
                            <select class="custom-select" v-model="typeform.type" @change="getData($event)" :class="{ 'is-invalid':$v.typeform.type.$error }">
                                <option value="" selected>{{ trans.get('__JSON__.Please Select Type') }}</option>
                                <option value="Category" selected>{{ trans.get('__JSON__.Category') }}</option>
                                <option value="Product">{{ trans.get('__JSON__.Product') }}</option>
                                <option value="SubCategory">{{ trans.get('__JSON__.Sub Category') }}</option>
                                <!-- <option value="Brand">{{ trans.get('__JSON__.Brand') }}</option> -->
                            </select>
                            <div v-if="$v.typeform.type.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.type.required">{{ trans.get('__JSON__.Please select type') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Select Popular',{lang: this.typeform.type }) }}</label>
                            <div class="position-relative">              
                                <multiselect
                                    v-model="$v.typeform.type_id.$model"
                                    id="name"
                                    label="name"
                                    track-by="name"
                                    :placeholder="trans.get('__JSON__.Search')"
                                    open-direction="bottom"
                                    :options="items"
                                    :searchable="true"
                                    :loading="isLoading"
                                    :internal-search="true"
                                    :clear-on-select="false"
                                    :close-on-select="true"
                                    :max-height="600"
                                    :show-no-results="false"
                                    :hide-selected="true"
                                    @search-change="asyncPopularSearch"
                                    :class="{ 'is-invalid': $v.typeform.type_id.$error}"
                                >
                                    <template slot="tag" slot-scope="{ option, remove }">
                                        <span class="custom__tag">
                                            <span>{{ option.name }}</span>
                                            <span class="custom__remove" @click="remove(option)">❌</span>
                                        </span>
                                    </template>
                                    <template slot="clear" slot-scope="props">
                                        <div
                                            class="multiselect__clear"
                                            v-if="type.length"
                                            @mousedown.prevent.stop="clearAll(props.search)"
                                        ></div>
                                    </template>
                                    <span slot="noResult">{{ trans.get( "__JSON__.Oops! No elements found. Consider changing the search query") }}.</span>
                                </multiselect>
                                <div v-if="$v.typeform.type_id.$error" class="invalid-feedback">
                                    <span v-if="!$v.typeform.type_id.required">{{ trans.get('__JSON__.Please select',{lang: this.typeform.type }) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Add Popular Search') }}</button>
                        <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>